<template lang="pug">
  main.main.main_video-success
    header.main__header
      h1.main__title {{ $t('video-success.title') }}
    .main__container
      .main__content
        p.main__text Инженер сервисного центра Smart Group свяжется с вами через <strong>{{info.messenger}}</strong>, {{info.date}}, в <strong>{{info.time}}</strong> по номеру: <strong>{{info.login}}</strong>
        .main__footer
          a.link-back(@click="changeVideoCall") {{ $t('video-success.change') }}
          a.link-back(@click="cancelVideo") {{ $t('video-success.cancel') }}
</template>

<script>
import { mapGetters } from 'vuex'
import { api } from '../../store/http-common'
import objectToFormData from 'object-to-formdata'
export default {
  name: 'Video_Cancel',
  props: ['info'],
  methods: {
    cancelVideo () {
      let data = objectToFormData({
        ...this.info,
        status: 'closed'
      })

      api
        .post('/ajax.php?action=sg:service.api.videocall.update', data)
        .then(response => {
          if (response.data.data === true) {
            this.$router.push({ path: '/video-cancel' })
          }
        })
    },
    changeVideoCall () {
      this.$router.push({name: 'video', params: {info: {...this.info}}})
    }
  },
  computed: {
    ...mapGetters({
      callInfo: 'getVideoCall'
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Video/Video_Success.vue